import React, {useEffect, useRef} from "react";
import {withRouter} from "react-router-dom";
const pageStyle = {
  backgroundColor: 'white',
  width: '220mm',
  pageBreakAfter: 'always',
  pageBreakBefore: 'always',
  minHeight: '295mm',
  //maxHeight: '295mm',
  padding: '10mm',
  boxSizing: 'border-box',
  display: 'grid',
  gridTemplateAreas: `'header header header'
                      'article article article'
                      'footer footer footer'`,
  gridTemplateRows: 'auto 1fr auto',
  fontSize: '13px',
  fontFamily: 'Arial, Helvetica'
};

const headerStyles = {
  container: {
    display: 'flex',
    height: 'auto',
    justifyContent: 'space-between',
    gridArea: 'header',
    paddingTop: '16px',
    paddingBottom: '16px',
    fontFamily: 'Arial, Helvetica'
  },
  span: {
    marginTop: '5mm',
    fontSize: '13px',
    fontFamily: 'Arial, Helvetica',
  }
};

const contentStyles = {
  article: {
    gridArea: 'article',
    fontSize: '13px',
    overflow: 'hidden',
    fontFamily: 'Arial, Helvetica'
  },
  container: {
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    // marginBottom: '16px'
    fontSize: '13px',
    fontFamily: 'Arial, Helvetica'
  },
  span: {
    marginTop: '5mm',
    fontSize: '13px',
    fontFamily: 'Arial, Helvetica'
  },
  td:{
    fontSize: '13px',
    fontFamily: 'Arial, Helvetica'
  }
};

const footerStyles = {
  container: {
    borderTop: '1px solid black',
    paddingTop: '16px',
    paddingBottom: '16px',
    display: 'grid',
    gridTemplateAreas: "'section section section'",
    justifyContent: 'space-between',
    gridArea: 'footer',
    fontSize: '13px',
    fontFamily: 'Arial, Helvetica'
  },
  contact: {
    textAlign: 'center',
    gridArea: 'section'
  },
  website: {
    gridArea: 'section'
  },
  product: {
    textAlign: 'end',
    display: 'flex',
    flexDirection: 'column',
    gridArea: 'section',
    fontFamily: 'Arial, Helvetica'
  },
  span: {
    marginTop: '5mm',
    fontSize: '13px',
    fontFamily: 'Arial, Helvetica'
  }
};

const Header = ({productCode, removableArea, logo}) => {
  const RemovableArea = removableArea ? removableArea : <div></div>;
  return (
    <RemovableArea
      data-removable={true}
      id="header"
      style={headerStyles.container}
    >
      <span style={headerStyles.span}>
        <strong style={headerStyles.span}>{productCode}</strong>
      </span>
      <img alt="logo" src={logo}/>
    </RemovableArea>
  );
}

const Content = ({children, onContentOverflow, onContentLack}) => {
  const contentRef = useRef();

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      if (!contentRef)
        return;
      const children = contentRef.current?.children;
      const blockSize = children
        ? [...children].reduce((r, e) => r + e.clientHeight, 0)
        : 0;
      const parentHeight = contentRef.current?.parentElement?.clientHeight || 0;

      if (blockSize > parentHeight) {
        // eslint-disable-next-line no-unused-expressions
        onContentOverflow?.(blockSize - parentHeight);
      } else {
        // eslint-disable-next-line no-unused-expressions
        onContentLack?.(parentHeight - blockSize);
      }
    });
    resizeObserver.observe(contentRef.current);
    return () => contentRef.current
      && resizeObserver.unobserve(contentRef.current);
  }, []);

  return (
    <article style={contentStyles.article}>
      <div id="content" ref={contentRef} style={contentStyles.container}>
        {children}
      </div>
    </article>
  );
};

const Footer = ({website, contact, removableArea, productCode, date}) => {
  const RemovableArea = removableArea ? removableArea : <div></div>;
  return (
    <RemovableArea
      data-removable={true}
      id="footer"
      style={footerStyles.container}
    >
      <div style={footerStyles.website}>
        {website}
      </div>
      <div style={footerStyles.contact}>
        For technical questions, contact
        <br/>
        <span>
          <u>{contact}</u>
        </span>
      </div>
      <div style={footerStyles.product}>
        <span>{productCode}</span>
       
        <span>Rev {date}</span>
      </div>
    </RemovableArea>
  );
}

const businessUnitInfo = {
  mm: {
    logo: 'https://micro-measurements.com/sites/all/themes/vpg/logo.jpg',
    website: 'www.micro-measurements.com',
    contact: 'mm@vpgsensors.com'
  },
  blh: {
    logo: 'https://blhnobel.com/sites/all/themes/vpg/logo-new.png',
    website: 'www.blhnobel.com',
    contact: 'blh@vpgsensors.com'
  }
};

const Page = ({match, children, product, removableArea, ...restProps}) => {
  return (
    <div style={pageStyle} id="page">
      <Header
        productCode={product?.name}
        logo={businessUnitInfo[match.params.bu]?.logo}
        removableArea={removableArea}
      />
      <Content {...restProps}>
        {children}
      </Content>
      
      <Footer
        website={businessUnitInfo[match.params.bu]?.website}
        contact={businessUnitInfo[match.params.bu]?.contact}
        productCode={product?.doc_number}
        removableArea={removableArea}
        date={product?.updatedAt?.slice(0, 10)}
      />
    </div>
  );
}

export default withRouter(Page);
